//Controls
import { Modal, ModalBody, ModalFooter, Button } from "@gpstrackit/react-controls";

//Components
import { useSelector, useDispatch } from "react-redux";
import { useIntl } from "react-intl";

//Actions
import { scheduledReportsContactsOpenModal } from 'Redux/actions';

const Contacts = (props) => {
    const dispatch = useDispatch();
    const { messages } = useIntl();

    const { contactsOpenModal, contacts } = useSelector(state => state.scheduledReportsRedux);

    const closeModal = () => {
        dispatch(scheduledReportsContactsOpenModal(false));
    }

    return (
        <Modal
            open={contactsOpenModal}
            title={messages['scheduled_reports_emails']}
            loading={false}
            position="right"
            size="small"
            handleClose={closeModal}
        >
            <ModalBody>
                <div style={{ padding: '0 10px', marginBottom: 30 }}>
                    <ul style={{ margin: 0 }}>
                        {contacts && contacts.map((item, index) => (
                            <li key={index}>{item}</li>
                        ))}
                    </ul>
                </div>
            </ModalBody>
            <ModalFooter>
                <Button
                    className="btn-dark-blue"
                    onClick={() => closeModal()}
                >
                    {messages['close']}
                </Button>
            </ModalFooter>
        </Modal>
    )
}
export default Contacts;